
import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CircleService } from '../../main/circles/circle.service';
import { YourCirclesComponent } from '../../main/circles/your-circles/your-circles.component';
import { StreamService } from '../stream.service';

@Component({
  selector: 'app-deletemodal',
  templateUrl: './deletemodal.component.html',
  styleUrls: ['./deletemodal.component.scss']
})
export class DeletemodalComponent implements OnInit {
  // @ViewChild(YourCirclesComponent,null) yourCirclesComponent:YourCirclesComponent;
  @Input() fromParent;
  isLoading:boolean = false;
  constructor(private circleService:CircleService,public activeModal: NgbActiveModal,private modalService:NgbModal,private CircleService:CircleService,private router:Router,private _snackBar: MatSnackBar) { }

  ngOnInit() {
  }

  closeModal(sendData) {
    this.activeModal.close(sendData);
  }

actionBtn() {
  this.isLoading = true;
  this.CircleService.deleteCircle(this.fromParent.Id).subscribe(
    res => {
      this.isLoading = false; 
      if (res["message"] == "Success") {
        
this.router.navigate(['/main/circles/your-circle'])
this.closeModal('')

        this._snackBar.open("Circle deleted successfully !", "", {
          duration: 5000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"]
        });
       
      } else {
      }
    },
    err => {
      this.isLoading = false;
    }
  );
}

}
